import { useState, useEffect } from "react";
import { useUser } from "src/shared/context/UserContext";

export const useCategoryPageState = () => {
  const [showDeletedCategories, setShowDeletedCategories] = useState(false);
  const [page, setPage] = useState(0);
  const{userConfigration}=useUser()
  const [rowsPerPage, setRowsPerPage] = useState(userConfigration?.tableDefaultSize || 10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTerm, setFilteredTerm] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<{ id: string; name: string; type: string }>({ id: "", name: "", type: "" });

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilteredTerm(searchTerm);
    }, 1000);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  return {
    showDeletedCategories,
    setShowDeletedCategories,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    searchTerm,
    setSearchTerm,
    filteredTerm,
    isAddModalOpen,
    setIsAddModalOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    selectedCategory,
    setSelectedCategory,
  };
};
